import { FC, useState } from "react"
import { useTranslation } from "react-i18next"

import ConfirmModal from "components/ConfirmModal/ConfirmModal"
import { Grid, GridItem } from "components/Grid"
import Radio from "components/Radio/Radio"
import { ReservationCartCopyFlag } from "models/ReservationCart"

interface IReservationCopyModalProps {
    reservationNumber: string
    onCopy(copyFlag: ReservationCartCopyFlag): void
    onClose(): void
}

const ReservationCopyModal: FC<IReservationCopyModalProps> = ({
    reservationNumber,
    onCopy,
    onClose,
}) => {
    const { t } = useTranslation()
    const [copyFlag, setCopyFlag] = useState(ReservationCartCopyFlag.fixedAssets)

    return (
        <ConfirmModal
            title={`${t("reservation.copy.copyRequest")} ${reservationNumber}`}
            onClose={onClose}
            onConfirm={() => onCopy(copyFlag)}
            maxWidth="586px"
            confirmButtonLabel={t("common.copy")}>
            <div className="py-3">
                <label>
                    <Grid columns="max-content minmax(0, auto)"
                        className="mb-4">
                        <GridItem className="pl-1 pr-2 pt-half">
                            <Radio
                                checked={copyFlag === ReservationCartCopyFlag.fixedAssets}
                                onChange={() => setCopyFlag(ReservationCartCopyFlag.fixedAssets)}
                                name="reservation-copy-flag"
                            />
                        </GridItem>
                        <GridItem>
                            <div className={`${copyFlag !== ReservationCartCopyFlag.fixedAssets ? "color-grey-600" : ""} mb-1`}>
                                {t("reservation.copy.fixedAssets")}
                            </div>
                            <div className="color-grey-600">
                                {t("reservation.copy.fixedAssetsDescr")}
                            </div>
                        </GridItem>
                    </Grid>
                </label>
                <label>
                    <Grid columns="max-content minmax(0, auto)">
                        <GridItem className="pl-1 pr-2 pt-half">
                            <Radio
                                checked={copyFlag === ReservationCartCopyFlag.all}
                                onChange={() => setCopyFlag(ReservationCartCopyFlag.all)}
                                name="reservation-copy-flag"
                            />
                        </GridItem>
                        <GridItem>
                            <div className={`${copyFlag !== ReservationCartCopyFlag.all ? "color-grey-600" : ""} mb-1`}>
                                {t("reservation.copy.all")}
                            </div>
                            <div className="color-grey-600">
                                {t("reservation.copy.allDescr")}
                            </div>
                        </GridItem>
                    </Grid>
                </label>
            </div>
        </ConfirmModal>
    )
}

export default ReservationCopyModal
